// Centralized brand/static data

export const BRAND = {
  name: "Mason Massage & Wellness",
  tagline: "Relax and Rejuvenate — Wherever You Are",
  phone: "(865) 221-7543",
  phoneRaw: "+18652217543",
  email: "masonmassage865@gmail.com",
  serviceArea: "Knoxville · Maryville · Farragut · West Knoxville",
  founder: "Stephanie Mason, LMT",
};

export const SERVICES = [
  {
    id: "reset",
    name: "The Reset",
    description:
      "A peaceful mobile session designed to reset your mind and body wherever you are. Includes hot towel treatment + aromatherapy.",
    durations: [{ label: "60 min", price: 80 }],
    benefits: ["Hot towel treatment", "Aromatherapy", "Full-body relaxation"],
  },
  {
    id: "renewal",
    name: "The Renewal",
    description:
      "A deeper in-home relaxation experience with extended massage time, heat therapy, and 1 focus area of choice. Includes hot towel + essential oils.",
    durations: [{ label: "90 min", price: 110 }],
    benefits: ["Heat therapy", "1 focus area", "Essential oils"],
  },
  {
    id: "restoration",
    name: "The Restoration",
    description:
      "The ultimate full-body self-care session. Total restoration with warm stones, heat therapy, and customized pressure. Includes hot towel treatment.",
    durations: [{ label: "120 min", price: 150 }],
    benefits: ["Warm stones", "Heat therapy", "Customized pressure"],
  },
];

export const ADDONS = [
  { id: "aroma", name: "Aromatherapy Upgrade", price: 10 },
  { id: "hot-stone", name: "Hot Stone Enhancement", price: 20 },
  { id: "scalp-foot", name: "Scalp & Foot Renewal", price: 15 },
];

export const PRODUCTS = [
  {
    id: "p1",
    name: "Stone & Cedar Body Oil",
    price: 48,
    image:
      "https://images.unsplash.com/photo-1739950839930-ef45c078f316?w=900&q=80&auto=format&fit=crop",
    category: "Body Oils",
    description: "Cold-pressed grapeseed base with cedarwood and warm vanilla.",
  },
  {
    id: "p2",
    name: "Quiet Mind Pillow Mist",
    price: 32,
    image:
      "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?w=900&q=80&auto=format&fit=crop",
    category: "Aromatherapy",
    description: "Lavender, sweet orange, and Roman chamomile for restful sleep.",
  },
  {
    id: "p3",
    name: "Mineral Soak — Mountain Salt",
    price: 38,
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=900&q=80&auto=format&fit=crop",
    category: "Bath",
    description: "Pink Himalayan salt, eucalyptus, and arnica for tired muscles.",
  },
  {
    id: "p4",
    name: "Warm Hands Salve",
    price: 28,
    image:
      "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=900&q=80&auto=format&fit=crop",
    category: "Topicals",
    description: "Shea, beeswax, and ginger root — for joints and cold mornings.",
  },
  {
    id: "p5",
    name: "Ceramic Diffuser — Sand",
    price: 64,
    image:
      "https://images.unsplash.com/photo-1602928298849-325cec8771c0?w=900&q=80&auto=format&fit=crop",
    category: "Home",
    description: "Hand-thrown stoneware diffuser with whisper-quiet ultrasonic.",
  },
  {
    id: "p6",
    name: "Mason Signature Candle",
    price: 42,
    image:
      "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=900&q=80&auto=format&fit=crop",
    category: "Home",
    description: "Soy wax, smoked oak, fig leaf, and a quiet hint of cardamom.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Stephanie brought such a calm presence into my home — I forgot I was in my own living room. I haven't slept that well in months.",
    name: "Alicia R.",
    location: "Farragut, TN",
  },
  {
    quote:
      "I work on my feet all week. The deep tissue session felt like a full reset. She actually listens — and she's incredible at what she does.",
    name: "Marcus T.",
    location: "Knoxville, TN",
  },
  {
    quote:
      "Booked a prenatal session at 32 weeks and cried at how good it felt. Gentle, knowledgeable, and warm. Already rebooked.",
    name: "Jordan P.",
    location: "Maryville, TN",
  },
];

export const CREDENTIALS = [
  "Licensed Massage Therapist (LMT) — State of Tennessee",
  "650+ hours of clinical training",
  "Certified in Prenatal Massage Therapy",
  "Continuing education in Sports & Myofascial Release",
  "Fully insured & background-checked",
];
